import React from 'react';

import TabStrip from '~/components/Offers/Detail/OfferBuilder/shared/TabStrip';

import {
  useInclusionDraftsContext,
  usePackageOptionsContext,
  useSurchargeGridsContext,
} from './PricingToolSessionContext';
import { PRICING_TOOL_TABS } from './constants';
import { isUnfinishedInclusion } from './tabs/inclusions/inclusionsModel';
import { hasUnsetSurchargeFields } from './tabs/surcharges/surchargePeriodValidation';
import type { PricingToolTab } from './types';

interface Props {
  activeTab: PricingToolTab;
  onTabChange: (tab: PricingToolTab) => void;
}

export default function PricingToolToolbar({ activeTab, onTabChange }: Props) {
  const { drafts } = useInclusionDraftsContext();
  const { optionStates } = usePackageOptionsContext();
  const { session } = useSurchargeGridsContext();

  const counts = {
    inclusions: drafts.filter((draft) => isUnfinishedInclusion(draft, optionStates)).length || undefined,
    surcharges: session.grids.periods.filter(hasUnsetSurchargeFields).length || undefined,
  };

  return (
    <TabStrip activeTab={activeTab} counts={counts} isErrorCounts onTabChange={onTabChange} tabs={PRICING_TOOL_TABS} />
  );
}
